<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Đăng kí</h2>
        <!-- <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button> -->
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="16">

        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-filter">
        <el-col :span="5">
          <el-select v-model="filter.school_id" filterable clearable placeholder="Chọn trường" class="input-select" @change="changedSchool">
            <el-option
              v-for="item in lists.listSchool"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select" @change="changedLevel">
            <el-option
              v-for="item in lists.listLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.facult_id" filterable clearable placeholder="Chọn chuyên ngành" class="input-select" @change="changedFacult">
            <el-option
              v-for="item in lists.listFacult"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10"></el-col>

      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div style="padding-left: 5px">
            Hiển thị tới Đăng kí <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Đăng kí
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Học viên"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.user_name }}</span>
                <span>{{ scope.row.user_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info">
                <span v-if="scope.row.school_id">
                  <strong>Trường: </strong>
                  {{ scope.row.school_text }}
                </span>
                <span v-if="scope.row.level_id">
                  <strong>Phân hệ: </strong>
                  {{ scope.row.level_text }}
                </span>
                <span v-if="scope.row.facult_id">
                  <strong>Chuyên ngành: </strong>
                  {{ scope.row.facult_text }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Nhân viên xử lý"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.staff_name }}</span>
                <span>{{ scope.row.staff_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Số tiền"
            width="100">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.total_money_format }} đ</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="Thời gian">
            <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Hành động"
            width="180"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip v-if="scope.row.school_id > 0" effect="dark" content="Xếp lớp nhanh" placement="top">
                  <span @click="fetchClassPro(scope.row)">
                    <i class="fas fa-filter"></i>
                  </span>
                </el-tooltip>
                <el-tooltip v-if="scope.row.total_money == 0" effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top" v-if="accountInfo.user_type == 1">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Chọn lớp cho ' + classPro.modelData.user_name + ' - ' + classPro.modelData.user_email"
      :visible.sync="classPro.dialogVisible"
      width="45%">
      <div class="class-pro-list">
        <div
          class="class-pro-item"
          :class="[index == classPro.listClassPro.length - 1 ? 'class-pro-item-none' : '']"
          v-for="(item, index) in classPro.listClassPro"
          @click="addUserToClassPro(item)"
          :key="item.id">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column">
              <span><strong>Trường: </strong> {{ item.school_text }}</span>
              <span><strong>Hệ: </strong> {{ item.level_text }}</span>
              <span><strong>Chuyên ngành: </strong> {{ item.facult_text }}</span>
              <span><strong>Ngày tạo:</strong> {{ item.created_at }}</span>
            </div>
            <div class="d-flex flex-column align-items-end">
              <span><strong>Mã lớp: </strong> {{ item.code }}</span>
              <span><strong>Tổng số môn học:</strong> {{ item.count_course_current }}</span>
              <span><strong>Tổng số kì:</strong> {{ item.count_term_current }}</span>
              <span><strong>Tổng số học viên:</strong> {{ item.count_user_current }}</span>
              <span><strong>Giảng viên:</strong> {{ item.teachter_text }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Promotions',
  metaInfo () {
    return {
      title: 'Đăng kí'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      canSubmit: true,
      filter: {
        q: '',
        status: 0,
        daterange: '',
        school_id: '',
        level_id: '',
        facult_id: '',
        specialized_id: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: [],
        listTeacher: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      classPro: {
        dialogVisible: false,
        modelData: {},
        modelDataSub: {},
        listClassPro: []
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo']),
    ...mapGetters('classUsers', ['getSearchClassUserSchool', 'getSearchClassUserLevel', 'getSearchClassUserFacult']),
  },
  created() {
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchSchool()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    ...mapActions('classUsers', ['changeSearchClassUserSchool', 'changeSearchClassUserLevel', 'changeSearchClassUserFacult']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-users-index', text: 'Đăng kí' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'class-users-create'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      this.filter.school_id = this.getSearchClassUserSchool
      this.filter.level_id = this.getSearchClassUserLevel
      this.filter.facult_id = this.getSearchClassUserFacult

      axios.get('class-users', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'class-users-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'class-users-show', params: {id: model.id}})
    },
    updateModel (model) {
      // let routeData = this.$router.resolve({name: 'class-users-update', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'class-users-update', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('class-users/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa đăng lý lớp của: ' + model.user_email, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('class-users/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },

    // Xếp lớp nhanh:
    fetchClassPro (item) {
      this.loading = true
      let data = {
        'limit': -1,
        'status': 1,
        'school_id': item.school_id,
        'level_id': item.level_id,
        'facult_id': item.facult_id,
        'get_all': false
      }
      axios.get('class-pros', {params: data}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            let classPros = response.data
            if (classPros.length === 0) {
              this.$alert('Chưa có lớp nào được mở giống với yêu cầu đăng kí của học viên.')
            } else {
              this.classPro.dialogVisible = true
              this.classPro.modelData = item
              this.classPro.listClassPro = classPros
            }
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    addUserToClassPro (item) {
      let text = 'Thêm ' + this.classPro.modelData.user_name + ' vào lớp : ' + item.code + ' ?'
      this.$confirm(text, 'Xác nhận', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.addUserToClassProAction(item)
      }).catch(() => {

      })
    },
    addUserToClassProAction (item) {
      let data = {
        'class_pro_id': item.id,
        'status': 1
      }
      axios.put('class-users/' + this.classPro.modelData.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(this.classPro.modelData)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }

            this.classPro.dialogVisible = false
            this.classPro.modelData = {}
            this.classPro.listClassPro = []
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    changedSchool (payload) {
      this.changeSearchClassUserSchool (payload)
    },
    changedLevel (payload) {
      this.changeSearchClassUserLevel (payload)
    },
    changedFacult (payload) {
      this.changeSearchClassUserFacult (payload)
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.school_id': function () {
      this.filter.level_id = ''
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listLevel = []
      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.school_id) {
        this.fetchLevel()
      }
      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.level_id) {
        this.fetchFacult()
      }

      this.fetchDatabaseModel()
    },
    'filter.facult_id': function () {
      this.filter.specialized_id = ''

      this.lists.listSpecialized = []

      if (this.filter.facult_id) {
        this.fetchSpecialized()
      }

      this.fetchDatabaseModel()
    },
    'filter.specialized_id': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}

/*class-pro*/
.class-pro-list {
  min-height: 100px;
}
.class-pro-item {
  border-bottom: 1px solid #f1f1f1;
  padding: 5px 10px;
  margin-bottom: 5px;
  cursor: pointer;
}
.class-pro-item:hover {
  background-color: #f8f8f8;
}
.class-pro-item-none {
    border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/class-users/Index.vue